<template>
  <div id="BeyondPopup">
    <div class="top">
      <div class="print" @click="printComponent()">Print</div>
    </div>
    <div id="invoice">
      <div class="header">
        <img src="@/assets/broncos-logo.svg" />
        <br />
        <h2>2025 Denver Broncos Invoice</h2>
      </div>
      <div class="account-info">
        <div class="account-title">Account Information</div>
        <p>
          <!-- <span>Account #:</span> {{ global.userInfo.Account }} <br /> -->
          <span>Name:</span> {{ global.userInfo.fullName }} <br />
          <span>Phone:</span> {{ global.userInfo.phone }} <br />
          <span>Email:</span> {{ global.userInfo.email }} <br />
          <!-- <span>Address:</span> {{ global.userInfo.address }}, {{ global.userInfo.city }}, {{ global.userInfo.state }} {{ global.userInfo.zip }} -->
        </p>
      </div>
      <div class="account-summary">
        <div class="chart">
          <div class="row item">
            <span class="c0">Qty</span>
            <span class="c1">Description</span>
            <span class="c2">Section</span>
            <span class="c3">Row</span>
            <span class="c4">Seat(s)</span>
            <span class="c5">Price Per Seat</span>
            <span class="c6">Total</span>
          </div>
          <div 
            class="row"
            v-for="(info, index) in global.allUserAccs"
            :key="'seating' + index"
            :class="'row' + index"
          >
            <span class="c0">{{ info.numOfSeats }}</span>
            <span class="c1">{{ info.sectionDesc }}</span>
            <span class="c2">{{ info.section }}</span>
            <span class="c3">{{ info.row }}</span>
            <span class="c4">{{ info.firstSeat }}-{{ info.lastSeat }}</span>
            <span class="c5">{{ info.amountPerSeat | toCurrency }}</span>
            <span class="c6">{{ info.amountTotal | toCurrency }}</span>
          </div>
          <div class="summary">
            <div class="total">
              <div class="row">
                <span>Credit:</span>
                <span class="number">{{ getCredit | toCurrency }}</span>
              </div>
              <div class="row due">
                <span>Total Due:</span>
                <span>{{ getTotalDue - getCredit | toCurrency }}</span>
              </div> 
            </div>
          </div>
        </div>
      </div>
      <div class="bottom-info">
        <div class="block">
          <p class="bold">Please make checks payable and remit to:</p>
          <p>Denver Broncos<br />1701 Bryant Street #100<br />Denver, CO 80204</p>
        </div>
        <div class="block">
          <p class="bold orange">Important</p>
          <p>It is only necessary to print and return this invoice if you are paying via check.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "BeyondPopup",
  computed: {
    ...mapState(["global"]),
    getTotalDue() {
      return this.global.allUserAccs
        .map((item) => parseFloat(item.amountTotal.substr(1).replaceAll(',','')))
        .reduce((prev, next) => prev + next);
    },
    getCredit() {
      return this.global.allUserAccs
        .map((item) => parseFloat(item.paidAmount.substr(1).replaceAll(',','')))
        .reduce((prev, next) => prev + next);
    }
  },
  data() {
    return {
      signature: "",
      blank: false,
    };
  },
  mounted() {
    setTimeout(() => {
      this.signature = this.global.userInfo.signature;
      if (this.global.userInfo.signature === "") {
        this.blank = true;
      } else {
        this.blank = false;
      }
    }, 1000);
  },
  methods: {
    printComponent() {
      var printContent = document.getElementById("invoice").innerHTML;
      let stylesHtml = "BeyondInvoicePopup.scss";
      for (const node of [
        ...document.querySelectorAll('link[rel="stylesheet"], style'),
      ]) {
        stylesHtml += node.outerHtml;
      }

      const WinPrint = window.open(
        "",
        "",
        "left=0,top=0,width=900,toolbar=0,scrollbars=0,status=0"
      );

      WinPrint.document.write(`<!DOCTYPE html>
      <html>
        <head>
          ${stylesHtml}
        </head>
        <body>
          ${printContent}
        </body>
      </html>`);

      WinPrint.document.close();
      WinPrint.focus();
      WinPrint.print();
      WinPrint.close();
    },
  },
};
</script>

<style lang="scss" scoped>
#BeyondPopup {
  width: 100%;
  max-width: 940px;
  background-color: #fff;
  margin: 0;
  h1 {
    font-family: AvenirNextCondensed-Bold;
    font-size: 24px;
    line-height: 30px;
    color: #f26522;
    padding: 0 50px;
    margin-top: 15px;
  }
  h2 {
    font-family: AvenirNextCondensed-Bold;
    font-size: 20px;
    line-height: 30px;
    color: #666;
    text-align: center;
    padding: 0 50px;
    span {
      font-family: AvenirNextCondensed-Medium;
    }
  }
  h3 {
    font-family: AvenirNextCondensed-Bold;
    font-size: 20px;
    line-height: 50px;
    text-align: center;
    color: #061632;
    border-top: 1px solid #061632;
    border-bottom: 1px solid #061632;
    margin-bottom: 25px;
    background: #ccc;
    padding: 0 50px;
    width: 100%;
  }
  h4 {
    font-family: AvenirNextCondensed-Bold;
    font-size: 20px;
    line-height: 28px;
    color: #000;
    text-align: center;
    padding: 0 50px;
  }
  p {
    font-family: AvenirNextCondensed-Medium;
    font-size: 14px;
    line-height: 18px;
    color: #000;
    padding: 0 50px;
  }

  .top {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 50px;
    width: 100%;
    background: #f26522;
    .print {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 130px;
      padding: 5px;
      font-family: AvenirNextCondensed-Bold;
      font-family: 20px;
      line-height: 20px;
      text-transform: uppercase;
      color: #061632;
      border: 2px solid #061632;
      background: #fff;
      cursor: pointer;
    }
  }
  #invoice {
    display: flex;
    flex-direction: column;
    .header {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 25px 0;
      width: 100%;
      border-bottom: 1px solid #000;
      img {
        height: 73px;
        object-fit: contain;
      }
      h2 {
        text-transform: uppercase;
      }
    }
    .account-info {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 40px 50px;
      border-bottom: 1px solid #000;
      .account-title {
        font-family: AvenirNextCondensed-Bold;
        font-size: 19px;
        line-height: 24px;
        font-weight: 700;
        color: #F26522;
      }
      p {
        padding: 0;
        text-align: center;
        span {
          font-family: AvenirNextCondensed-Bold;
        }
      }
      @media (max-width: $sm) {
        padding: 20px;
      }
    }
    .account-summary {
      padding: 40px 50px;
      border-bottom: 1px solid #000;
      @media (max-width: $sm) {
        padding: 20px;
      }
      .chart {
        position: relative;
        display: block;
        width: 100%;
        height: auto;
        @media (max-width: $sm) {
          zoom: 0.46;
          zoom: 46%;
          -ms-zoom: 46%;
        }
        .row {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 100%;
          height: auto;
          padding: 5px 0;
          border-bottom: 1px solid #C9C9C9;
          &.item {
            border-bottom: 2px solid #000;
            padding: 10px 0;
            span {
              font-family: AvenirNextCondensed-Bold;
              font-size: 18px;
              line-height: 20px;
              text-transform: uppercase;
            }
          }
          span {
            font-family: AvenirNextCondensed-Medium;
            font-size: 16px;
            line-height: 18px;
            padding: 0 5px;
            text-align: center;
            color: #000;
            &.c0 { width: 70px; }
            &.c1 { width: calc(100% - 540px); text-align: left; }
            &.c2 { width: 100px; }
            &.c3 { width: 50px; }
            &.c4 { width: 60px; }
            &.c5 { width: 160px; }
            &.c6 { width: 100px; text-align: right; }
            &.number { font-family: AvenirNextCondensed-Bold; }
          }
        }
        .summary {
          position: relative;
          display: flex;
          justify-content: flex-end;
          width: 100%;
          margin-top: 20px;
          .total {
            position: relative;
            display: block;
            width: 300px;
            .row {
              border-bottom: 0;
              &.due {
                border-top: 1px solid #000;
                margin-top: 5px;
                padding-top: 5px;
                span {
                  font-family: AvenirNextCondensed-Bold;
                  font-size: 20px;
                  line-height: 1;
                }
              }
            }
          }
        }
      }
    }
    .bottom-info {
      position: relative;
      display: flex;
      width: 100%;
      justify-content: space-evenly;
      padding: 40px 50px;
      .block {
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 320px;
        padding: 10px;
        text-align: center;
        p {
          font-family: AvenirNextCondensed-Medium;
          font-size: 14px;
          line-height: 18px;
          color: #000;
          margin: 3px 0;
          padding: 0;
          &.bold {
            font-family: AvenirNextCondensed-Bold;
            font-size: 16px;
            line-height: 18px;
          }
          &.orange {
            color: #F26522;
            text-transform: uppercase;
          }
        }
      }
      @media (max-width: $sm) {
        flex-direction: column;
        padding: 20px;
      }
    }
  }
}
</style>